import React, { Component } from 'react'

import { scroller } from 'react-scroll'

import some from 'lodash/some'

type ScrollToProps = {
  hashList: string[]
}

interface ScrollToPropsWithChildren
  extends React.PropsWithChildren<ScrollToProps> {}

/**
 * A component that allows using hash-based links to scroll to lazy-loaded components
 *
 * @param props.hashList - a list of hash values which should all cause the
 *    browser to scroll to this element
 * @returns - the children components with a prepended empty span to serve as
 *    a scroll target. The span will have an ID matching the first value in
 *    hashList
 */
// eslint-disable-next-line import/prefer-default-export
export class ScrollTo extends Component<ScrollToPropsWithChildren> {
  componentDidMount() {
    const { hashList } = this.props
    const hasHash =
      window.location.hash &&
      some(hashList, (hash) => window.location.hash === `#${hash}`)
    if (hasHash && hashList.length > 0) {
      setTimeout(() => {
        scroller.scrollTo(hashList[0], {
          duration: 750,
          offset: -25,
          smooth: true,
          spy: true
        })
      }, 500)
    }
  }

  render() {
    /* eslint-disable-next-line react/prop-types */
    const { children, hashList } = this.props
    if (hashList.length === 0) return children
    return (
      <>
        <span id={hashList[0]} />
        {children}
      </>
    )
  }
}
